// @flow

import * as React from "react"
import {NavLink, withRouter} from "react-router-dom"
import {connect} from "react-redux"
import {withTranslation} from "react-i18next"

import Config from "../../config"
import Icon from "../icon"
import FuzzyProductFinder from "../fuzzy-product-finder"
import ActionDot from "../action-dot"
import {toggleRevealedProduct} from "../../actions/products"
import {
  getAllProductsWithChildren,
  getProductSet,
} from "../../reducers/products"
import type {
  ProductsByCategory,
  ProductCategory,
  Product,
  ProductSet,
  BabyList,
  Baby,
  Dispatch,
  Family,
  State as ReduxState,
} from "../../types"

type Props = {
  +t: any,
  +match: any,
  +family: ?Family,
  +baby: Baby,
  +history: any,
  +dispatch: Dispatch,
  +products: $ReadOnlyArray<ProductsByCategory>,
  +categories: $ReadOnlyArray<ProductCategory>,
  +babyList: BabyList,
  +productsWithChildren: $ReadOnlyArray<Product | ProductSet>,
}

class IntakeHeader extends React.Component<Props> {
  handleFuzzySelected: (Product | ProductSet) => void

  constructor(props: Props) {
    super(props)
    this.handleFuzzySelected = this.handleFuzzySelected.bind(this)
  }

  handleFuzzySelected(item: Product | ProductSet) {
    const {
      dispatch,
      products,
      history,
      match: {
        params: {babyToken},
      },
    } = this.props
    // Jumpid
    const {categoryId, id, isSet} = item
    let productLink = isSet ? `ps${id}` : `p${id}`
    // In case of product set product item
    if (!isSet && item.productSetId) {
      const productSetId = parseInt(item.productSetId)
      productLink = `ps${productSetId}`
      const productSet = getProductSet(productSetId, products)
      // Toggle parent product
      if (productSet) {
        dispatch(toggleRevealedProduct(productSet))
      }
    } else {
      // Toggle all children
      if (isSet) {
        item.products.forEach((product) => {
          // Toggle
          dispatch(toggleRevealedProduct(product.product))
        })
      }
      // Toggle
      dispatch(toggleRevealedProduct(item))
    }
    // Go to
    history.push(`/intake/${babyToken}/categories/${categoryId}/${productLink}`)
  }

  render() {
    const {
      t,
      family,
      match: {
        params: {babyToken},
      },
      categories,
      productsWithChildren,
      baby,
      babyList,
    } = this.props
    return (
      <div className="intake-header">
        <div className="l">
          <a href={`${Config.baseUrl}/admin/babies`}>
            <img
              className="mic-mac-logo"
              src={`${Config.baseUrl}/images/logo.png`}
            />
          </a>
          <h1 className="h3 m-0 ml-4">{family ? family.name : ""}</h1>
        </div>
        <div className="r">
          <ActionDot babyToken={babyToken} />
          <div className="search">
            <FuzzyProductFinder
              products={productsWithChildren}
              babyList={babyList}
              onSelect={this.handleFuzzySelected}
            />
          </div>
          <nav className="intake-header-nav">
            <ul>
              <li>
                <PathNavLink
                  matchpath={`/intake/${babyToken}/data/`}
                  to={`/intake/${babyToken}/data/general`}
                  activeClassName="is-active"
                >
                  <Icon name="icon-family" />
                  <span>{t("intake.header.nav.data")}</span>
                </PathNavLink>
              </li>
              {categories && categories.length > 0 && (
                <li>
                  <PathNavLink
                    matchpath={`/intake/${babyToken}/categories/`}
                    to={`/intake/${babyToken}/categories/${categories[0].id}`}
                    activeClassName="is-active"
                  >
                    <Icon name="icon-box" />
                    <span>{t("intake.header.nav.products")}</span>
                  </PathNavLink>
                </li>
              )}
              <li>
                <PathNavLink
                  matchpath={`/intake/${babyToken}/list`}
                  to={`/intake/${babyToken}/list`}
                  activeClassName="is-active"
                >
                  <Icon name="icon-stork" />
                  <span>{t("intake.header.nav.babyList")}</span>
                </PathNavLink>
              </li>
              <li>
                <a href={`${Config.baseUrl}/admin/babies/${baby.id}`}>
                  <span>{t("intake.header.nav.admin")}</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    )
  }
}
export const PathNavLink = (props: any) => (
  <NavLink
    isActive={(_, {pathname}) => pathname.indexOf(props.matchpath) == 0}
    {...props}
  />
)

const mapStateToProps = (state: ReduxState): any => ({
  family: state.baby.baby ? state.baby.baby.family : null,
  products: state.products.entities.products,
  productsWithChildren: getAllProductsWithChildren(
    state.products.entities.products
  ),
  baby: state.baby.baby,
  babyList: state.baby.list,
})

export default withTranslation()(
  withRouter(connect(mapStateToProps)(IntakeHeader))
)
